import React, { useState, useEffect } from 'react';
import api from '../services/api';
import { useNavigate } from 'react-router-dom';

import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { Card, CardBody, CardTitle } from 'reactstrap';

const CreateItinerary = () => {
  const navigate = useNavigate();
  const [locations, setLocations] = useState([]);
  const [packages, setPackages] = useState([]);
  const [selectedPackage, setSelectedPackage] = useState('');
  const [selectedLocation, setSelectedLocation] = useState('');
  const [date, setDate] = useState('');
  const [description, setDescription] = useState('');
  const [errors, setErrors] = useState({});

  useEffect(() => {
    const fetchLocations = async () => {
      const response = await api.get('/locations');
      setLocations(response.data);
    };

    const fetchPackages = async () => {
      const response = await api.get('/cards');
      setPackages(response.data);
    };

    fetchLocations();
    fetchPackages();
  }, []);

  const validateForm = () => {
    const errors = {};

    if (!selectedPackage) errors.selectedPackage = 'please select a package';
    if (!selectedLocation) errors.selectedLocation = 'please select a location';
    if (!date) errors.date = 'day cannot be empty';
    if (!description.trim()) errors.description = 'description cannot be empty';

    return errors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const errors = validateForm();
    if (Object.keys(errors).length > 0) {
      setErrors(errors);
      return;
    }
    setErrors({});

    const formData = new FormData();
    formData.append('locationId', selectedLocation);
    formData.append('date', date);
    formData.append('description', description);
    formData.append('cardId', selectedPackage);

    try {
      const response = await api.post('/itineraries', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });

      if (response.status === 200 || response.status === 201) {
        setTimeout(() => {
          alert('Itinerary created successfully!');
        }, 1000);
        setTimeout(() => {
          navigate('/manage-itinerary', { replace: true });
        }, 1000);
      } else {
        alert('Failed to create itinerary');
      }
    } catch (error) {
      console.error('Error creating itinerary:', error);
      alert('Error creating itinerary');
    }
  };

  const handleCancel = () => {
    setSelectedPackage('');
    setSelectedLocation('');
    setDate('');
    setDescription('');
    navigate('/manage-itinerary');
  };

  return (
    <div className='container mt-3 mb-5'>
      <CardTitle tag='h5' className='mb-3'>
        Itinerary List <span style={{ color: '#B0B0B0' }}>/ Add Itinerary</span>
      </CardTitle>
      <Card>
        <CardBody>
          <form onSubmit={handleSubmit}>
            <div className='col-xl-8'>

              <div className='mb-3'>
                <label className='form-label'>Select Package *</label>
                <select className={`form-control ${errors.selectedPackage ? 'is-invalid' : ''}`} value={selectedPackage} onChange={(e) => setSelectedPackage(e.target.value)} >
                  <option value=''>Select Package</option>
                  {packages.map((pkg) => (
                    <option key={pkg.id} value={pkg.id}>
                      {pkg.category.name} - {pkg.vendor.name}
                    </option>
                  ))}
                </select>
                <b>{errors.selectedPackage && <span className='text-danger small'>{errors.selectedPackage}</span>}</b>
              </div>

              <div className='mb-3'>
                <label className='form-label'>Select Location *</label>
                <select className={`form-control ${errors.selectedLocation ? 'is-invalid' : ''}`} value={selectedLocation} onChange={(e) => setSelectedLocation(e.target.value)} >
                  <option value=''>Select Location</option>
                  {locations.map((location) => (
                    <option key={location.id} value={location.id}>
                      {location.location}
                    </option>
                  ))}
                </select>
                <b>{errors.selectedLocation && <span className='text-danger small'>{errors.selectedLocation}</span>}</b>
              </div>

              <div className='mb-3'>
                <label className='form-label'>Day *</label>
                <input type='text' className={`form-control ${errors.date ? 'is-invalid' : ''}`} value={date} onChange={(e) => setDate(e.target.value)} />
                <b>{errors.date && <span className='text-danger small'>{errors.date}</span>}</b>
              </div>

              <div className='mb-3'>
                <label className='form-label'>Description *</label>
                <ReactQuill value={description} onChange={setDescription} className='' placeholder='Enter Description' />
                <b>{errors.description && <span className='text-danger small'>{errors.description}</span>}</b>
              </div>

              <div className='button-group'>
                <button type='submit' className='btn btn-success submit-button'>Submit</button>
                <button type='button' className='btn btn-danger cancel-button' onClick={handleCancel}>Cancel</button>
              </div>
              
            </div>
          </form>
        </CardBody>
      </Card>
    </div>
  );
};

export default CreateItinerary;
